<template>
  <div class="app-container">
    <el-table
      :data="tableData"
      style="width: 100%"
      :header-cell-style="{
        backgroundColor: '#0E59CB',
        color: '#fff',
      }"
      :default-sort="{ prop: 'date', order: 'descending' }"
      ref="singleTable"
      :highlight-selection-row="false"
      :row-class-name="tableRowClassName"
    >
      <el-table-column
        prop="date"
        show-overflow-tooltip
        label="项目编号"
        sortable
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="address"
        show-overflow-tooltip
        label="详址"
        sortable
        width="280"
      >
      </el-table-column>
      <el-table-column
        prop="sqsj"
        show-overflow-tooltip
        label="申请时间"
        sortable
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="lczt"
        show-overflow-tooltip
        label="流程状态"
        sortable
        width="120"
      >
      </el-table-column>

      <el-table-column
        prop="nr"
        sortable
        label="维修内容和具体地点"
        show-overflow-tooltip
      >
      </el-table-column>
    </el-table>
    <Pagination
      style="margin-top: 10px"
      v-show="query.total > 0"
      :total="query.total"
      :limit.sync="query.pageSize"
      :page.sync="query.pageNum"
      round="false"
      :currentPageSize="query.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      @pagination="initPage"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      query: {
        total: 0,
        pageNum: 1,
        pageSize: 6,
      },
    };
  },
  mounted() {
    this.query.total = this.tableData.length;
  },
  methods: {
    initPage() {},
    //奇偶行背景色不同
    tableRowClassName({ rowIndex }) {
      if ((rowIndex + 1) % 2 === 0) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep.el-table .warning-row {
  background-color: #0f53a5 !important;
  color: #fff !important;
}

::v-deep.el-table .success-row {
  background-color: #193a5c !important;
  color: #fff !important;
}
::v-deep.el-table tbody tr:hover > td {
  background-color: unset !important;
}
::v-deep.el-table__body {
  border-color: #0f53a5 !important;
}

.el-table {
  border-bottom: 1px solid #1763e8;
  border-right: 1px solid #1763e8;
  margin: 0 auto;
}

::v-deep.el-table th {
  border: 1px solid #1763e8 !important;
  border-right: none !important;
  border-bottom: none !important;
}

::v-deep.el-table td {
  border: 1px solid #1763e8;
  border-right: none !important;
  border-bottom: none !important;
}

::v-deep .el-table__empty-block {
  background-color: #0e59cb;
}
::v-deep .el-table__empty-text {
  color: #fff;
}
</style>
